export const DOMAIN_NAME = 'airwick.us';
export const HOST_NAME = `https://www.${DOMAIN_NAME}`;

export const LOCALES = {
  us: { code: 'en-us', url: '/', lang: 'us' },
  es: { code: 'en-es', url: '/es/', lang: 'es' },
};

export const URLS = {
  home: {
    us: { url: LOCALES.us.url, fullUrl: LOCALES.us.url },
    es: { url: LOCALES.es.url, fullUrl: LOCALES.es.url },
  },
  notFound: {
    us: { url: '/404/', fullUrl: '/404/' },
    es: { url: '/404/', fullUrl: `${LOCALES.es.url}404/` },
  },
  search: {
    us: { url: '/search-result-page.html/', fullUrl: '/search-result-page.html/' },
    es: { url: '/search-result-page.html/', fullUrl: `${LOCALES.es.url}search-result-page.html/` },
  },
  subscribe: {
    us: { url: '/subscribe1/', fullUrl: '/subscribe1/' },
    es: { url: '/subscribe1/', fullUrl: `${LOCALES.es.url}subscribe1/` },
  },
  products: {
    us: { url: '/products/', fullUrl: '/products/' },
    es: { url: '/products/', fullUrl: `${LOCALES.es.url}products/` },
  },
  allFragrances: {
    us: { url: '/all-fragrances/', fullUrl: '/all-fragrances/' },
    es: { url: '/all-fragrances/', fullUrl: `${LOCALES.es.url}all-fragrances/` },
  },
  sitemap: {
    us: { url: '/sitemap/', fullUrl: '/sitemap/' },
    es: { url: '/sitemap/', fullUrl: `${LOCALES.es.url}sitemap/` },
  },
};
